import { RotateCcw } from 'lucide-react';
import type { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Button } from '@nucleus-commerce/ui/components/button';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@nucleus-commerce/ui/components/form';
import { Textarea } from '@nucleus-commerce/ui/components/textarea';

import type { TryItValues } from '../../schemas/try-it-form-schema';

/** The JSON body as text, checked as JSON on send, with a way back to the recorded example. */
export function BodyEditor({
  control,
  onReset,
}: {
  control: Control<TryItValues>;
  onReset: () => void;
}) {
  const { t } = useTranslation('docs');
  return (
    <FormField
      control={control}
      name="body"
      render={({ field }) => (
        <FormItem className="gap-1.5">
          <div className="flex items-center justify-between gap-2">
            <FormLabel className="text-sm">{t('tryIt.body')}</FormLabel>
            <Button type="button" variant="ghost" size="sm" className="h-7" onClick={onReset}>
              <RotateCcw aria-hidden />
              {t('tryIt.resetBody')}
            </Button>
          </div>
          <FormControl>
            <Textarea
              rows={10}
              spellCheck={false}
              autoComplete="off"
              className="max-h-96 font-mono text-[12.5px] leading-relaxed"
              {...field}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
